import CTAButtons from '../CTAButtons/CTAButtons';
import styles from './CTASection.module.css';

function CTASection() {
  return (
    <section className={`section ${styles.section}`} aria-labelledby="cta-heading">
      <div className={`container ${styles.inner}`}>
        <h2 id="cta-heading" className={styles.title}>
          Ready to bring in-seat ordering to your venue?
        </h2>
        <p className={styles.subtitle}>
          Request a demo to see how ONI helps stadium and arena teams grow concession revenue without adding lines.
        </p>
        <CTAButtons size="lg" showAdmin={false} layout="row" className={styles.ctas} />
      </div>
    </section>
  );
}

export default CTASection;
